import React from 'react';

import MoodBoardCreateForm from '@features/trend-research/components/moodboard/addMoodboard/MoodboardCreatForm';
import MoodBoardList from '@features/trend-research/components/moodboard/addMoodboard/MoodboardList';

const MoodboardCreate = ({
	closeModal,
	setPage,
	setDebouncedSearch,
	setIsGetMoodboard,
	selectMyMoodboard,
	isGetMoodboard,
	onSearch,
	debouncedSearch,
	setThreeApi
}) => {
	return (
		<div className="added-to-favorite-popup shadow-12dp p-3 ">
			<div className="header d-flex justify-content-between align-items-center">
				<p className="regular-18 gray_dark_01">Added to a Moodboard</p>
				<img
					onClick={() => closeModal(false)}
					className="cursor-pointer"
					src={`${process.env.PUBLIC_URL}/icons/close.svg`}
					width="24"
					alt=""
				/>
			</div>
			<MoodBoardCreateForm
				setDebouncedSearch={setDebouncedSearch}
				setIsGetMoodboard={setIsGetMoodboard}
				isGetMoodboard={isGetMoodboard}
				setPage={setPage}
				onSearch={onSearch}
				debouncedSearch={debouncedSearch}
				setThreeApi={setThreeApi}
			/>
			<MoodBoardList
				setPage={setPage}
				selectMyMoodboard={selectMyMoodboard}
				isGetMoodboard={isGetMoodboard}
				debouncedSearch={debouncedSearch}
			/>
		</div>
	);
};

export default MoodboardCreate;
